export type OrderCategoryId = 'printing' | 'rawMaterialsAndPackage';

/**
 * Категория заказа. На бэке (OrderCategory) — только id и name.
 */
class OrderCategory {
    public id:   OrderCategoryId;
    public name: string;

    /** Захардкоженные категории. Нужны фабрикам синхронно, до загрузки словаря с бэка. */
    static ALL: ReadonlyMap<OrderCategoryId, OrderCategory> = new Map([
        ['printing',               OrderCategory.fromValues('printing',               'Полиграфия')],
        ['rawMaterialsAndPackage', OrderCategory.fromValues('rawMaterialsAndPackage', 'Сырье и упаковка')],
    ]);

    toString() { return this.name }

    static fromValues(id: OrderCategoryId, name: string): OrderCategory {
        const result = new OrderCategory();

        result.id   = id;
        result.name = name;

        return result;
    }

    static fromServer(data: any, result = new OrderCategory()): OrderCategory {
        result.id   = data.id;
        result.name = data.name;

        return result;
    }
}

export default OrderCategory;
